module.exports = __webpack_public_path__ + "img/slovan-bratislava-logo-icon.bdf9a618.png";